<template>
	<div class="leftres">
		<div>
			<div :class="showorhide ? 'inputtop' : 'inputtops'">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="producselect" :key="index" :options="item.options"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"
                        :pt="item.pt"
                        @remoteMethod="remoteMethod"></Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :qhide="false" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>

			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<SaleBillRepeatInfoTable :tableData="tableData" :total="total" @proExport="proExport"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></SaleBillRepeatInfoTable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '@/components/common-dropdownlist.vue'
	import CommonBtngroup from '@/components/commongroup.vue'
	import SaleBillRepeatInfoTable from './components/saleBillRepeatInfoTable.vue'
	import utils from '@/common/utils'
	import {
		InventoryClassList
	} from '@/api/home'
    import { GetInvNameList } from '@/api/newsapi'
	import {
		GetSaleBillRepeatInfoList,
		ExportSaleBillRepeatInfo
	} from '@/api/saleBillRepeatInfo'

	export default {
		name: 'SaleBillRepeatInfo',
		components: {
			Commondropdownlist,
			SaleBillRepeatInfoTable,
			CommonBtngroup
		},
		data() {
			return {
				total: 0,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				showorhide: true,
				invClass: "",
				invName: "",
                terminalHospital: "",
                buyerName: "",
                sbDate: "",
				formdata: [{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '100px',
						options: []
					},
					{
						inputdata: '',
						title: '产品',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入检索',
						types: '',
						inputtype: 'selectautocomplete',
						width: '210px',
						lablewith: '100px',
                        options: [],
                        pt: true
					},
                    {
						inputdata: '',
						title: '医院',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
                    {
						inputdata: '',
						title: '付款方',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
                    {
						inputdata: '',
						title: '开票日期',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择日期',
						types: '',
						inputtype: 'dates',
						width: '210px',
						lablewith: '100px'
					}
				]
			}
		},
		mounted() {
			this.getList()
			this.getInventoryClassList()
		},
		methods: {
			// 列表
			async getList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await GetSaleBillRepeatInfoList({
					InvClass: this.invClass,
					InvName: this.invName,
                    TerminalHospital: this.terminalHospital,
                    BuyerName: this.buyerName,
                    SBDate: this.sbDate,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
				loading.close();
			},
			// 产品线
			async getInventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[0].options = []
					data.data.map((item) => {
						this.formdata[0].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
            // 产品检索
            async remoteMethod(query) {
                if (query !== "") {
                    let { code, data } = await GetInvNameList({
                        InvName: query
                    });
                    if (code == 0) {
                        let arr = [];
                        data.map((item) => {
                            arr.push({
                                key: item.InvName,
                                value: item.InvName
                            });
                        });
                        this.formdata[1].options = arr;
                    }
                } else {
                    this.formdata[1].options = [];
                }
            },
			// 导出
			async proExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportSaleBillRepeatInfo({
					InvClass: this.invClass,
					InvName: this.invName,
                    TerminalHospital: this.terminalHospital,
                    BuyerName: this.buyerName,
                    SBDate: this.sbDate,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `发票判重档案导出${str}`, "xlsx")
					loading.close();
				} else {
					this.$message.warning('导出失败');
					loading.close();
				}
			},
			reset() {
				this.$refs.producselect.map((item) => {
					item.modelvalue = ''
				})
			},
			hide() {
				this.showorhide = false
			},
			showclick() {
				this.showorhide = true
			},
			select() {
				try {
					this.pageindex = 1
					this.invClass = this.$refs.producselect[0].modelvalue
					this.invName = this.$refs.producselect[1].modelvalue
                    this.terminalHospital = this.$refs.producselect[2].modelvalue
                    this.buyerName = this.$refs.producselect[3].modelvalue
                    this.sbDate = this.$refs.producselect[4].modelvalue
					this.getList()
				} catch (error) {
					this.getList()
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.getList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.getList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: auto;
		min-height: 10px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: visible;
		position: relative;
	}

	.inputtops {
		width: 980px;
		height: 20px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 15px;
		margin-right: 0px;
	}
</style>
